module.exports = __webpack_public_path__ + "static/company_img-b271adc63fbb05a87ae390f3b4e88f0a.png";